import { ReactNode } from "react";

interface ClassicThemeProps {
  children: ReactNode;
  themeColor: string;
  headingColor: string;
  buttonColor: string;
}

export default function ClassicTheme({ children, themeColor, headingColor, buttonColor }: ClassicThemeProps) {
  return (
    <div className="classic-theme">
      <style>{`
        .classic-theme {
          --theme-color: ${themeColor};
          --heading-color: ${headingColor};
          --button-color: ${buttonColor};
        }
        
        .classic-theme .course-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
        }
        
        .classic-theme .course-card {
          background: white;
          border-radius: 1.5rem;
          overflow: hidden;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }
        
        .classic-theme .course-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        }
        
        .classic-theme .hero-section {
          background: linear-gradient(135deg, ${themeColor}, ${headingColor});
          padding: 4rem 2rem;
          border-radius: 2rem;
          margin-bottom: 3rem;
        }
        
        .classic-theme .section-title {
          color: ${headingColor};
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
        }
        
        .classic-theme .cta-button {
          background: ${buttonColor};
          color: white;
          padding: 1rem 2rem;
          border-radius: 1rem;
          font-weight: 700;
          transition: all 0.3s ease;
        }
        
        .classic-theme .cta-button:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
      `}</style>
      {children}
    </div>
  );
}
